/**
 * 项目管理模块路由配置
 * 父级使用 RouteOutlet 确保子路由正确匹配。
 */
import type { RouteRecordRaw } from 'vue-router'
import { Permission } from '@/utils/permission'
import { MyProjects, ProjectDetail } from '@/modules/project/views'
import RouteOutlet from '@/components/layout/RouteOutlet.vue'

const projectRoutes: RouteRecordRaw[] = [
  {
    path: 'project',
    name: 'Project',
    component: RouteOutlet,
    redirect: { name: 'MyProjects' },
    meta: {
      titleKey: 'menu.project',
      title: '项目管理',
      requiresAuth: true,
      // 与 DB permission_code 一致：任一项目权限即可见
      permissions: [
        Permission.PROJECT_LIST,
        Permission.PROJECT_VIEW,
        Permission.PROJECT_CREATE,
        Permission.PROJECT_EDIT,
        Permission.PROJECT_DELETE,
        Permission.PROJECT_EXPORT
      ],
      icon: 'ProjectOutlined'
    },
    children: [
      {
        path: 'my-projects',
        name: 'MyProjects',
        component: MyProjects,
        meta: {
          titleKey: 'menu.myProjects',
          title: '我的项目',
          requiresAuth: true,
          permissions: [Permission.PROJECT_LIST, Permission.PROJECT_VIEW],
          breadcrumb: true
        }
      },
      {
        path: ':id',
        name: 'ProjectDetail',
        component: ProjectDetail,
        meta: {
          titleKey: 'menu.projectDetail',
          title: '项目详情',
          requiresAuth: true,
          permissions: [Permission.PROJECT_LIST, Permission.PROJECT_VIEW],
          breadcrumb: true,
          hidden: true
        }
      }
    ]
  }
]

export default projectRoutes
